// extracted by mini-css-extract-plugin
export default {"articleListingHeader":"ArticleListingPage_articleListingHeader__PZizM"};